// import * as BABYLON from "babylonjs";
// import RootObjects from "./RootObjects";
// import AudioManager from "scripts/util/AudioManager";
// import EventPubSub from "scripts/util/EventPubSub";

class Snowmen {
  static init(snowmen, numOfSnowmen = 6) {
    this.NUM_OF_SNOWMEN = numOfSnowmen;
    this.current = 0;
    this.snowmen = snowmen;
  }

  static placeSnowman(config, myParent) {
    this.snowmen[this.current].placeSnowman(config, myParent, this.current);
    this.current++;
    if (this.current >= this.NUM_OF_SNOWMEN) this.current = 0;
  }

  static update() {
    for (let i = 0; i < this.NUM_OF_SNOWMEN; i++) this.snowmen[i].update();
  }
}

export default Snowmen;
